module.exports = __webpack_public_path__ + "8f68b4771dbfb30f602a61bf8d178bf1.svg";